"use client";

import React from "react";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <footer
      className="text-white py-16"
      style={{
        background: "linear-gradient(0deg, #0C0927 0%, #233C78 100%)",
      }}
    >
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold mb-6 text-[#dfa428]">
              نخلة بابل للدعاية والإعلان
            </h3>
            <p className="text-gray-300 leading-relaxed mb-6">
              الشركة الرائدة في مجال الدعاية والإعلان في العراق منذ عام 2012
            </p>
            <div className="flex gap-4">
              <motion.a
                href="https://www.facebook.com/share/1BLRmq95ZY/"
                className="blue-cursor w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#dfa428] hover:text-[#0a367b] transition-all duration-300"
                whileHover={{ scale: 1.1, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 5 3.66 9.13 8.44 9.88v-6.99H7.9v-2.89h2.54V9.84c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.89h-2.34v6.99C18.34 21.13 22 17 22 12z" />
                </svg>
              </motion.a>
              <motion.a
                href="https://www.instagram.com/palmofbabylon?igsh=NnZmOWY3MmlqaTFi"
                className="blue-cursor w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#dfa428] hover:text-[#0a367b] transition-all duration-300"
                whileHover={{ scale: 1.1, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M7 2C4.24 2 2 4.24 2 7v10c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5H7zm10 2c1.65 0 3 1.35 3 3v10c0 1.65-1.35 3-3 3H7c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" />
                </svg>
              </motion.a>
              <motion.a
                href="https://www.linkedin.com/company/palm-of-babylon/"
                className="blue-cursor w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#dfa428] hover:text-[#0a367b] transition-all duration-300"
                whileHover={{ scale: 1.1, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.25c-.97 0-1.75-.78-1.75-1.75s.78-1.75 1.75-1.75 1.75.78 1.75 1.75-.78 1.75-1.75 1.75zm13.5 11.25h-3v-5.5c0-1.38-.03-3.16-1.93-3.16-1.93 0-2.23 1.51-2.23 3.06v5.6h-3v-10h2.88v1.36h.04c.4-.75 1.38-1.54 2.84-1.54 3.04 0 3.6 2 3.6 4.59v5.59z" />
                </svg>
              </motion.a>

              <motion.a
                href="https://www.youtube.com/@palmofbabylon"
                className="blue-cursor w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#dfa428] hover:text-[#0a367b] transition-all duration-300"
                whileHover={{ scale: 1.1, rotate: 360 }}
                transition={{ duration: 0.3 }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M19.615 3.184C21.05 3.566 22 4.758 22 6.264v11.472c0 1.506-.95 2.698-2.385 3.08-2.1.502-10.615.502-10.615.502s-8.515 0-10.615-.502C1.95 20.434 1 19.242 1 17.736V6.264c0-1.506.95-2.698 2.385-3.08C5.485 2.682 14 2.682 14 2.682s8.515 0 10.615.502zM10 8v8l7-4-7-4z" />
                </svg>
              </motion.a>
            </div>
          </motion.div>

          {/* Services */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-bold mb-6">خدماتنا</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/services"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  الشاشات الإعلانية
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  اللوحات الإعلانية
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  الإعلان في المراكز التجارية
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  التسويق الإلكتروني
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-bold mb-6">روابط سريعة</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="/about"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  عن الشركة
                </a>
              </li>
              <li>
                <a
                  href="/portfolio"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  أعمالنا
                </a>
              </li>
              <li>
                <a
                  href="/news"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  المقالات
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-gray-300 hover:text-[#dfa428] transition-colors duration-300"
                >
                  تواصل معنا
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
          >
            <h4 className="text-xl font-bold mb-6">معلومات التواصل</h4>

            <div className="space-y-4">
              {/* Address */}
              <div className="flex items-center space-x-3 space-x-reverse">
                <a
                  href="https://maps.app.goo.gl/vJQRjFWg75GJRcFH7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:underline"
                >
                  العراق، بغداد، الجادرية، قرب البنك المركزي{" "}
                </a>
              </div>

              {/* Phone (WhatsApp) */}
              <div className="flex items-center space-x-3 space-x-reverse">
                <a
                  href="https://wa.me/9647800800900" // Iraq country code 964 + number without 0 or dashes
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:underline"
                >
                  0780-080-0900
                </a>
              </div>

              {/* Email */}
              <div className="flex items-center space-x-3 space-x-reverse">
                <a
                  href="mailto:info@palmofbabylon.com"
                  className="text-gray-300 hover:underline"
                >
                  info@palmofbabylon.com
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="border-t border-white/20 mt-12 pt-8 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
        >
          <p className="text-gray-300">© 2026 نخلة بابل. جميع الحقوق محفوظة.</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
